import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
`

const Image = styled.img`
  width: 64px;
  height: 64px;
  opacity: 0.2;
  margin-bottom: 24px;
`

const Text = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: var(--color-text-secondary);
  margin: 0;
`

export { Container, Image, Text }
